export default __webpack_public_path__ + "static/media/payment-failed.ed08a41d.svg";